export default "__VITE_ASSET__BpR3gAsB__"